import ProductAssetsFullScreenThumbnails from './ProductAssetsFullScreenThumbnails'
import ProductAssetsFullScreenZoomControls from './ProductAssetsFullScreenZoomControls'
import ProductAssetsFullscreenCarousel from './ProductAssetsFullscreenCarousel'
import { AssetType } from '../ProductAssets.types'
import { useEffect } from 'react'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'

type ProductAssetsFullScreenProps = {
  assets: Array<AssetType>
  assetToPreview: AssetType
  isTablet: boolean
  onClose: () => void
}

const ProductAssetsFullScreen = ({
  assets,
  assetToPreview,
  onClose,
  isTablet,
}: ProductAssetsFullScreenProps) => {
  useEffect(() => {
    // add class
    document.querySelector('html')?.classList.add('product-assets-fullscreen-open')

    return () => {
      document.querySelector('html')?.classList.remove('product-assets-fullscreen-open')
    }
  }, [])

  return (
    <div className='product-fullscreen-modal product-assets-fullscreen'>
      <button onClick={onClose} type='button' className='product-assets-fullscreen-close'>
        <Icon iconName={Icons.CLOSE} />
      </button>
      <div className='product-assets-fullscreen-content'>
        <ProductAssetsFullscreenCarousel assets={assets} assetToPreview={assetToPreview} />
        <ProductAssetsFullScreenThumbnails assets={assets} />
        {!isTablet && <ProductAssetsFullScreenZoomControls />}
      </div>
    </div>
  )
}

export default ProductAssetsFullScreen
